<template>
  <v-dialog v-model="show" :max-width="maxWidth" @input="closeDialog" scrollable>
    <v-card elevation="0">
      <v-card-title class="pb-4 text-h5 d-flex column-gap-2"
        >{{ title }}
        <v-spacer />
        <v-btn @click="deleteImage" color="grey white--text" small fab elevation="0" class="delete-btn">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
        <!-- <v-btn :href="imageSrc" color="blue white--text" small fab elevation="1"
          ><v-icon>mdi-lead-pencil</v-icon></v-btn
        > -->
        <v-btn :href="imageSrc" color="blue white--text" small fab elevation="1"><v-icon>mdi-download</v-icon></v-btn>
      </v-card-title>
      <v-card-subtitle>{{ subtitle }}</v-card-subtitle>
      <v-card-text>
        <v-img :src="imageSrc" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ReferenceImageDialog',
  props: {
    maxWidth: {
      type: [String, Number],
      default: '60vw',
    },
  },
  data() {
    return {
      show: false,
      imageSrc: null,
      title: null,
      subtitle: null,
      id: null,
    }
  },
  methods: {
    openDialog(image) {
      this.show = true
      this.description = image.description = image.description ?? ''
      this.imageSrc = image.url
      this.title = `Data de referência: ${this.$moment(image.referenceDate).format('DD/MM/YYYY')}`
      this.subtitle = `${image.description}`
      this.id = image.id
    },
    closeDialog() {
      this.show = false
      this.imageSrc = null
      this.title = null
      this.subtitle = null
      this.id = null
    },
    async deleteImage() {
      await this.$api.removePatientAttendanceFile(this.id)
      this.show = false
      this.imageSrc = null
      this.title = null
      this.subtitle = null
      this.id = null
      this.$emit('image-deleted')
    },
  },
}
</script>

<style scoped>
:deep(.delete-btn:hover) {
  color: red;
}
</style>
